import React, { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { getToken } from '../../lib/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function download(file) {
  const res = await fetch(`${BACKEND_URL}/api/admin/quote-artwork/${file.id}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url;
  a.download = file.filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export default function QuoteArtwork({ files }) {
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState('');
  if (!files?.length) return null;
  const onClick = async (f) => {
    setBusy(f.id);
    setError('');
    try { await download(f); } catch (e) { setError(e.message); } finally { setBusy(null); }
  };
  return (
    <div className="mb-6" data-testid="admin-quote-artwork">
      <p className="text-xs uppercase tracking-[0.18em] text-[#cfc8bb] mb-2">Artwork</p>
      <div className="flex flex-wrap gap-2">
        {files.map((f) => (
          <button
            key={f.id}
            type="button"
            onClick={() => onClick(f)}
            className="inline-flex items-center gap-2 rounded-lg border border-white/10 px-3 py-2 text-sm text-[#f4efe6] hover:border-[#00b8ff]"
            data-testid={`admin-artwork-download-${f.id}`}
          >
            {busy === f.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4 text-[#00b8ff]" />}
            {f.filename}
            <span className="text-xs text-[#7a7a7a]">{f.size < 1024 ? `${f.size} B` : `${Math.round(f.size / 1024)} KB`}</span>
          </button>
        ))}
      </div>
      {error && <p className="text-xs text-red-400 mt-2">{error}</p>}
    </div>
  );
}
